<template>
  <v-card data-cy="carrousel-home" class="minified-carrousel-card">
    <mf-loading :boolean-loader="loading" loader-type="dynamic" :dynamic-amount="3">
      <div class="carrousel-container">
        <div class="carrousel-track">
          <div v-for="(item, index) in clonedItems" :key="index" class="carrousel-item">
            <h1>{{ item.title }}</h1>

            <h2><b v-if="item.currency">R$</b>{{ item.value }}<span v-if="item.percentage">%</span></h2>
            <p v-if="item.showExtra" class="mb-0">
              <mf-tooltip :disabled="!item.tooltip" max-width="200" bottom variant="secondary">
                <template #activator="{ on }">
                  <b :class="getExtraClass(item.extra)">{{ parseFloat(item.extra) > 0 ? '+' : '' }}{{ item.extra ? item.extra : 0 }}%</b>
                  {{ getExtraLabel(item.extraType) }}
                </template>
                {{ item.tooltip }}
              </mf-tooltip>
            </p>
          </div>
        </div>
      </div>
    </mf-loading>
  </v-card>
</template>

<script>
import { localeString } from '@/config/helpers.js'
export default {
  name: 'MinifiedCarrousel',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: [
      {
        id: 1,
        title: 'Faturamento',
        tooltip: 'Tooltip 1',
        value: localeString(123456, 0),
        currency: true,
        percentage: false,
        extra: localeString(15.4, 1),
        showExtra: true,
        extraType: 'year',
      },
      {
        id: 2,
        title: 'Cupons',
        tooltip: 'Tooltip 2',
        value: localeString(225156, 0),
        currency: false,
        percentage: false,
        extra: localeString(0, 1),
        showExtra: true,
        extraType: 'year',
      },
      {
        id: 3,
        title: 'Faturamento identificado',
        tooltip: 'Tooltip 3',
        value: localeString(45.9, 1),
        currency: false,
        percentage: true,
        extra: localeString(-50, 1),
        showExtra: true,
        extraType: 'month',
      },
      { id: 4, title: 'Ticket médio - Geral', tooltip: 'Tooltip 4', value: localeString(123456, 2), currency: true, percentage: false, showExtra: false },
      {
        id: 5,
        title: 'Ticket médio - Clube',
        tooltip: 'Tooltip 5',
        value: localeString(225156, 2),
        currency: true,
        percentage: false,
        extra: localeString(12, 1),
        showExtra: true,
        extraType: 'club',
      },
      { id: 6, title: 'Ticket médio - Fora clube', tooltip: 'Tooltip 6', value: localeString(45.9, 2), currency: true, percentage: true, showExtra: false },
      {
        id: 7,
        title: 'Média cupons - Clube',
        tooltip: 'Tooltip 7',
        value: localeString(3.85, 2),
        currency: false,
        percentage: false,
        extra: localeString(15.4, 1),
        showExtra: true,
        extraType: 'year',
      },
      {
        id: 8,
        title: 'Gasto médio - Clube',
        tooltip: 'Tooltip 8',
        value: localeString(597.72, 2),
        currency: true,
        percentage: false,
        extra: localeString(15.4, 1),
        showExtra: true,
        extraType: 'year',
      },
    ],
  }),
  computed: {
    clonedItems() {
      return [...this.data, ...this.data]
    },
  },
  methods: {
    getExtraClass(value) {
      const formattedValue = parseFloat(value)
      if (formattedValue > 0) return 'extra-positive'
      else if (formattedValue === 0) return 'extra-null'
      else return 'extra-negative'
    },
    getExtraLabel(extraType) {
      if (extraType === 'year') return 'em relação ao ano anterior'
      else if (extraType === 'month') return 'em relação ao mês anterior'
      else return 'de um cliente não clube'
    },
  },
}
</script>

<style lang="scss" scoped>
.minified-carrousel-card {
  height: 118px;
  border-radius: 8px !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16) !important;
  width: 100%;
  padding: 16px 0px 16px 16px;

  .carrousel-container {
    width: 100%;
    overflow: hidden;
    mask: linear-gradient(90deg, transparent, #fff 10%, #fff 90%, transparent);
  }

  .carrousel-track {
    width: max-content;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    animation: move 40s linear infinite;

    &:hover {
      animation-play-state: paused;
    }
  }

  .carrousel-item {
    width: 265px;
    padding-right: 20px;
    border-right: 2px solid $cinza-l70;

    h1 {
      color: $cinza-d20;
      font-weight: 400;
      font-size: 16px;
      margin-right: 8px;
      margin-bottom: 0;
      line-height: 19.2px;
    }

    h2 {
      font-size: 24px;
      font-weight: 700;
      line-height: 28.8px;
      color: $cinza-d10;
      margin: 8px 0;

      b {
        color: $cinza-l40;
        font-weight: 700;
      }
    }

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 16.8px;
      color: $cinza-0;

      b {
        font-weight: 700;
      }

      .extra-positive {
        color: $verde-0;
      }
      .extra-null {
        color: $cinza-0;
      }
      .extra-negative {
        color: $vermelho-0;
      }
    }
  }
}

@keyframes move {
  to {
    transform: translate(calc(-50% - 10px));
  }
}
</style>
